// src/layouts/AppLayout.jsx — Sidebar + TopBar + main content wrapper
import React from 'react';
import { useLocation } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import TopBar from '../components/TopBar';
import ToastStack from '../features/notifications/components/ToastStack';

export default function AppLayout({
  children,
  auth,
  logout,
  sidebarCategories,
  onCategoryFilter,
  onNotRelated,
  isNotRelated,
  activeCategoryFilter,
  search,
  setSearch,
  navigate,
}) {
  const location = useLocation();
  const activeView = location.pathname === '/settings' ? 'settings' : 'overview';

  // Only show search in TopBar when on overview page
  const showSearch = activeView === 'overview';

  return (
    <>
      <Sidebar
        activeView={activeView}
        onView={view => view === 'settings' ? navigate('/settings') : navigate('/overview')}
        sidebarCategories={sidebarCategories || { total: 0, items: [] }}
        onCategoryFilter={onCategoryFilter}
        onNotRelated={onNotRelated}
        isNotRelated={isNotRelated}
        activeCategoryFilter={activeCategoryFilter}
        onLogout={logout}
        auth={auth}
      />
      <main className="main">
        <TopBar
          search={showSearch ? search : ''}
          setSearch={showSearch ? setSearch : () => {}}
          activeView={activeView}
        />
        <div key={location.pathname} className="fade-slide-up">
          {children}
        </div>
      </main>
      <ToastStack />
    </>
  );
}
